import { render, staticRenderFns } from "./AssignedCompetencyDetail.vue?vue&type=template&id=491801ff&scoped=true"
import script from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
export * from "./AssignedCompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignedCompetencyDetail.vue?vue&type=style&index=0&id=491801ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491801ff",
  null
  
)

export default component.exports